import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ReadOnlyProvider } from "@/components/items/readOnly";
import { validateViewSearch } from "@/components/items/viewSearch";
import { RowSkeleton } from "@/components/ui";
import { useKeyAliasRedirect } from "@/data/aliases";
import { useCatalogState } from "@/data/CatalogProvider";
import { useSpaces } from "@/data/catalog";

/** Product views share `?q=`, `?group=`, `?sort=` and `?peek=`. */
export const Route = createFileRoute("/_app/p/$productKey")({
  validateSearch: validateViewSearch,
  component: ProductLayout,
});

/**
 * Everything below is read-only while the product (or its space) is archived. A key the catalog does not know may be
 * a former key of a renamed product: it is looked up and the URL moves to the current key.
 */
function ProductLayout() {
  const { productKey } = Route.useParams();
  const { catalog } = useCatalogState();
  const spaces = useSpaces();
  const product = catalog.productByKey.get(productKey.toUpperCase());
  const alias = useKeyAliasRedirect("product", productKey, !product && !spaces.isPending);
  if (alias.pending) return <RowSkeleton rows={8} className="pt-24" />;
  return (
    <ReadOnlyProvider value={catalog.isArchived(product?.id)}>
      <Outlet />
    </ReadOnlyProvider>
  );
}
